import React, {useEffect, useState} from 'react'
import {getEnterpriseName} from '../../../../api'
import Select from "react-select";
import Swal from 'sweetalert2'

interface ApiEnterpriseNameProps {
  selectedEnterprise: number | null;
  setSelectedEnterprise: (value: number | null) => void;
}

const ApiEnterpriseName: React.FC<ApiEnterpriseNameProps> = ({
  selectedEnterprise,
  setSelectedEnterprise,
}) => {
  const [enterpriseName, setEnterpriseName] = useState([]);

  const sortEnterprises = (enterprises) => {
    return enterprises.sort((a, b) => a.name.localeCompare(b.name));
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      width: "200px", // Fixed width for the input field
      minHeight: "50px", // Minimum height of the input box
      maxHeight: "60px", // Allow up to two rows of selected users
      overflowY: "auto", // Enable vertical scroll when more than two rows are selected
      flexWrap: "wrap", // Ensure chips wrap into rows
    }),
    menu: (base) => ({
      ...base,
      width: "200px", // Match dropdown menu width with control
    }),
    multiValue: (base) => ({
      ...base,
    }),
    multiValueLabel: (base) => ({
      ...base,
      whiteSpace: "nowrap", // Prevent text wrapping for long user names
      overflow: "hidden", // Hide overflow text
      textOverflow: "ellipsis", // Add ellipsis for long names
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "red", // Color for the remove button
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#ffe6e6", // Red background on hover
      },
    }),
  };

  useEffect(() => {
    const fetchEnterprises = async () => {
      try {
        const response = await getEnterpriseName();
        const sortedEnterprises = sortEnterprises(response);
        setEnterpriseName(sortedEnterprises.map((enterprise) => ({
          value: enterprise.id,
          label: enterprise.name,
        })));
      } catch (error) {
        console.error('Error fetching enterprise names:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch enterprises. Please try again later.',
        });
      }
    };

    fetchEnterprises();
  }, []);

  const handleSelectionChange = (selectedOption) => {
    setSelectedEnterprise(selectedOption ? selectedOption.value : null);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px' }}>
       <Select
          options={enterpriseName}
          onChange={handleSelectionChange}
          placeholder="Search Enterprise"
          isClearable
          styles={customStyles}
        />
     
    </div>
  );
};

export default ApiEnterpriseName
